module.exports = __webpack_public_path__ + "static/media/fr_podcast_player_play_icon.7fca4a49.svg";